"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var edit_icon_svg_1 = __importDefault(require("res/img/edit-icon.svg"));
var delete_icon_svg_1 = __importDefault(require("res/img/delete-icon.svg"));
var ClientsTableRow = function (_a) {
    var data = _a.data, onDelete = _a.onDelete;
    return (react_1.default.createElement("div", { className: 'table-row flex flex-row' },
        react_1.default.createElement("div", { className: 'table-row__td' },
            react_1.default.createElement("span", null, data.firstName)),
        react_1.default.createElement("div", { className: 'table-row__td' },
            react_1.default.createElement("span", null, data.lastName)),
        react_1.default.createElement("div", { className: 'table-row__td' },
            react_1.default.createElement("span", null,
                react_1.default.createElement("a", { href: "mailto:" + data.emailAddress, title: 'Email Address', target: '_blank', rel: 'noreferrer' }, data.emailAddress))),
        react_1.default.createElement("div", { className: 'table-row__td flex flex-row' },
            react_1.default.createElement(react_router_dom_1.Link, { to: "/users/edit/" + data.id, className: 'table-row__action flex flex-column flex-center', title: 'Edit', "aria-label": 'Edit User' },
                react_1.default.createElement("img", { src: edit_icon_svg_1.default, alt: 'Edit' })),
            react_1.default.createElement("button", { className: 'table-row__action flex flex-column flex-center', title: 'Delete', onClick: function () { return onDelete(data); }, "aria-label": 'Delete User' },
                react_1.default.createElement("img", { src: delete_icon_svg_1.default, alt: 'Delete' })))));
};
exports.default = ClientsTableRow;
